import { getPadScheduleStateByEnum } from '../utils';
import { ClientService } from '../../../../../../shared/api/ClientService';

const ScheduleStateLabel = ({ state }: { state?: ClientService.PADScheduleStateEnum }) => {
  const data = getPadScheduleStateByEnum(state);
  return <span style={{ color: data?.color, fontWeight: 600 }}>{data?.label}</span>;
};

export default ScheduleStateLabel;
